// // // // import React, { useEffect } from "react";
// // // // import "./StoresInfo.css";
// // // // import AOS from "aos";
// // // // import "aos/dist/aos.css";
// // // // import { LocationOn, AccessTime, Phone } from "@mui/icons-material";

// // // // const StoresInfo = () => {
// // // //   useEffect(() => {
// // // //     AOS.init({ duration: 1200, once: true });
// // // //   }, []);

// // // //   const stores = [
// // // //     {
// // // //       img: "/store1.jpg",
// // // //       title: "Space 1 – Bakelore Madhapur Experience Centre",
// // // //       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
// // // //       address: "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034991",
// // // //     },
// // // //     {
// // // //       img: "/store2.jpg",
// // // //       title: "Space 2 – Bakelore Banjara Hills Flagship Retail Store",
// // // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // // //       address: "House 8-2-323/1/B, Ubi Colony, Green Valley, Road 3, Banjara Hills, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034992",
// // // //     },
// // // //     {
// // // //       img: "/store3.jpg",
// // // //       title: "Space 3 – Bakelore Kondapur Flagship Retail Store",
// // // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // // //       address: "Plot 60, Ground Floor, Masjid Banda, Kondapur, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034983",
// // // //     },
// // // //     {
// // // //       img: "/store4.jpg",
// // // //       title: "Space 4 – Bakelore Kokapet To-Go Store",
// // // //       desc: "Pick up your coffee, dessert, sandwich or cake on the run, with cozy seats to stay if you choose.",
// // // //       address: "98DW+4JG, SN Nagar, Manchirevula, Kokapet, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 7997000791",
// // // //     },
// // // //   ];

// // // //   return (
// // // //     <div className="stores-wrapper">
// // // //       <h1 className="stores-title" data-aos="fade-down">
// // // //         STORES INFO
// // // //       </h1>

// // // //       <div className="stores-grid">
// // // //         {stores.map((item, index) => (
// // // //           <div className="store-card" data-aos="fade-up" data-aos-delay={index * 200}>
// // // //             <div className="arch-image">
// // // //               <img src={item.img} alt={item.title} />
// // // //             </div>

// // // //             <h3 className="store-title">{item.title}</h3>
// // // //             <p className="store-desc">{item.desc}</p>

// // // //             <div className="store-info">
// // // //               <p className="info-item">
// // // //                 <LocationOn className="icon" /> {item.address}
// // // //               </p>
// // // //               <p className="info-item">
// // // //                 <AccessTime className="icon" /> {item.timings}
// // // //               </p>
// // // //               <p className="info-item">
// // // //                 <Phone className="icon" /> {item.phone}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StoresInfo;

// // // // import React from "react";
// // // // import "./StoresInfo.css";

// // // // // React Icons
// // // // import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

// // // // const StoresInfo = () => {
// // // //   const stores = [
// // // //     {
// // // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // // //       title: "Space 1 – Bakelore Madhapur Experience Centre",
// // // //       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
// // // //       address:
// // // //         "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034991",
// // // //     },
// // // //     {
// // // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // // //       title: "Space 2 – Bakelore Banjara Hills Flagship Retail Store",
// // // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // // //       address:
// // // //         "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034992",
// // // //     },
// // // //     {
// // // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // // //       title: "Space 3 – Bakelore Kondapur Flagship Retail Store",
// // // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // // //       address:
// // // //         "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 8121034983",
// // // //     },
// // // //     {
// // // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // // //       title: "Space 4 – Bakelore Kokapet To-Go Store",
// // // //       desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
// // // //       address:
// // // //         "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
// // // //       timings: "8:30 AM – 12 Midnight",
// // // //       phone: "+91 7997000791",
// // // //     },
// // // //   ];

// // // //   return (
// // // //     <div className="stores-wrapper">
// // // //       <h1 className="stores-title">STORES INFO</h1>

// // // //       <div className="stores-grid">
// // // //         {stores.map((item, index) => (
// // // //           <div className="store-card" key={index}>
// // // //             <div className="arch-image">
// // // //               <img src={item.img} alt={item.title} />
// // // //             </div>

// // // //             <h3 className="store-title">{item.title}</h3>
// // // //             <p className="store-desc">{item.desc}</p>

// // // //             <div className="store-info">
// // // //               <p className="info-item">
// // // //                 <MdLocationOn className="icon" /> {item.address}
// // // //               </p>

// // // //               <p className="info-item">
// // // //                 <MdAccessTime className="icon" /> {item.timings}
// // // //               </p>

// // // //               <p className="info-item">
// // // //                 <MdPhone className="icon" /> {item.phone}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StoresInfo;

// // // import React from "react";
// // // import "./StoresInfo.css";

// // // // React Icons
// // // import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

// // // const StoresInfo = () => {
// // //   const stores = [
// // //     {
// // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // //       title: "Space 1 – Bakelore Madhapur Experience Centre",
// // //       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
// // //       address:
// // //         "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
// // //       timings: "8:30 AM – 12 Midnight",
// // //       phone: "+91 8121034991",
// // //     },
// // //     {
// // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // //       title: "Space 2 – Bakelore Banjara Hills Flagship Retail Store",
// // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // //       address:
// // //         "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
// // //       timings: "8:30 AM – 12 Midnight",
// // //       phone: "+91 8121034992",
// // //     },
// // //     {
// // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // //       title: "Space 3 – Bakelore Kondapur Flagship Retail Store",
// // //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// // //       address:
// // //         "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
// // //       timings: "8:30 AM – 12 Midnight",
// // //       phone: "+91 8121034983",
// // //     },
// // //     {
// // //       img: "https://bakelore.com/images/bakelore-hero-1.png",
// // //       title: "Space 4 – Bakelore Kokapet To-Go Store",
// // //       desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
// // //       address:
// // //         "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
// // //       timings: "8:30 AM – 12 Midnight",
// // //       phone: "+91 7997000791",
// // //     },
// // //   ];

// // //   return (
// // //     <div className="stores-wrapper">
// // //       <h1 className="stores-title">STORES INFO</h1>

// // //       <div className="stores-grid">
// // //         {stores.map((item, index) => (
// // //           <div className="store-card" key={index}>
// // //             <div className="arch-image">
// // //               <img src={item.img} alt={item.title} />
// // //             </div>

// // //             <h3 className="store-title">{item.title}</h3>
// // //             <p className="store-desc">{item.desc}</p>

// // //             <div className="store-info">
// // //               <p className="info-item">
// // //                 <span className="icon-circle">
// // //                   <MdLocationOn />
// // //                 </span>
// // //                 {item.address}
// // //               </p>

// // //               <p className="info-item">
// // //                 <span className="icon-circle">
// // //                   <MdAccessTime />
// // //                 </span>
// // //                 {item.timings}
// // //               </p>

// // //               <p className="info-item">
// // //                 <span className="icon-circle">
// // //                   <MdPhone />
// // //                 </span>
// // //                 {item.phone}
// // //               </p>
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default StoresInfo;

// // import React from "react";
// // import "./StoresInfo.css";

// // // React Icons
// // import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

// // const StoresInfo = () => {
// //   const stores = [
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Madhapur-Experience-Centre.png",
// //       title: "Space 1 – Bakelore Madhapur Experience Centre",
// //       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
// //       address:
// //         "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034991",
// //     },
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Banjara-Hills-Flagship-Retail-Store.png",
// //       title: "Space 2 – Bakelore Banjara Hills Flagship Retail Store",
// //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// //       address:
// //         "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034992",
// //     },
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Kondapur-Flagship-Retail-Store.png",
// //       title: "Space 3 – Bakelore Kondapur Flagship Retail Store",
// //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// //       address:
// //         "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034983",
// //     },
// //     {
// //       img: "https://bakelore.com/images/bakelore-kokapet-to-go-store.png",
// //       title: "Space 4 – Bakelore Kokapet To-Go Store",
// //       desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
// //       address:
// //         "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 7997000791",
// //     },
// //   ];

// //   return (
// //     <div className="stores-wrapper">
// //       <h1 className="stores-title">STORES INFO</h1>

// //       <div className="stores-grid">
// //         {stores.map((item, index) => (
// //           <div
// //             className="store-card"
// //             key={index}
// //             style={{ "--i": index }} // animation delay
// //           >
// //             <div className="arch-image">
// //               <img src={item.img} alt={item.title} />
// //             </div>

// //             <h3 className="store-title">{item.title}</h3>
// //             <p className="store-desc">{item.desc}</p>

// //             <div className="store-info">
// //               <p className="info-item">
// //                 <span className="icon-circle">
// //                   <MdLocationOn />
// //                 </span>
// //                 {item.address}
// //               </p>

// //               <p className="info-item">
// //                 <span className="icon-circle">
// //                   <MdAccessTime />
// //                 </span>
// //                 {item.timings}
// //               </p>

// //               <p className="info-item">
// //                 <span className="icon-circle">
// //                   <MdPhone />
// //                 </span>
// //                 {item.phone}
// //               </p>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default StoresInfo;

// // import React from "react";
// // import "./StoresInfo.css";

// // // React Icons
// // import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

// // const StoresInfo = () => {
// //   const stores = [
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Madhapur-Experience-Centre.png",
// //       title: "Space 1 – Bakelore Madhapur Experience Centre",
// //       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
// //       address:
// //         "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034991",
// //     },
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Banjara-Hills-Flagship-Retail-Store.png",
// //       title: "Space 2 – Bakelore Banjara Hills Flagship Retail Store",
// //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// //       address:
// //         "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034992",
// //     },
// //     {
// //       img: "https://bakelore.com/images/Bakelore-Kondapur-Flagship-Retail-Store.png",
// //       title: "Space 3 – Bakelore Kondapur Flagship Retail Store",
// //       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
// //       address:
// //         "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 8121034983",
// //     },
// //     {
// //       img: "https://bakelore.com/images/bakelore-kokapet-to-go-store.png",
// //       title: "Space 4 – Bakelore Kokapet To-Go Store",
// //       desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
// //       address:
// //         "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
// //       timings: "8:30 AM – 12 Midnight",
// //       phone: "+91 7997000791",
// //     },
// //   ];

// //   return (
// //     <div className="stores-wrapper">
// //       <h1 className="stores-title">STORES INFO</h1>

// //       <div className="stores-grid">
// //         {stores.map((item, index) => (
// //           <div
// //             className="store-card"
// //             key={index}
// //             style={{ "--i": index }} // valid & safe
// //           >
// //             <div className="arch-image">
// //               <img src={item.img} alt={item.title} />
// //             </div>

// //             <h3 className="store-title">{item.title}</h3>
// //             <p className="store-desc">{item.desc}</p>

// //             <div className="store-info">
// //               <p className="info-item">
// //                 <span className="icon-circle" aria-hidden>
// //                   <MdLocationOn />
// //                 </span>
// //                 <span className="info-text">{item.address}</span>
// //               </p>

// //               <p className="info-item">
// //                 <span className="icon-circle" aria-hidden>
// //                   <MdAccessTime />
// //                 </span>
// //                 <span className="info-text">{item.timings}</span>
// //               </p>

// //               <p className="info-item">
// //                 <span className="icon-circle" aria-hidden>
// //                   <MdPhone />
// //                 </span>
// //                 <span className="info-text">{item.phone}</span>
// //               </p>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default StoresInfo;


// import React from "react";
// import "./StoresInfo.css";

// // React Icons
// import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

// const StoresInfo = () => {
//   const stores = [
//     {
//       img: "https://bakelore.com/images/Bakelore-Madhapur-Experience-Centre.png",
//       title: "Bakelore Madhapur Experience Centre",
//       desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
//       address:
//         "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
//       map: "https://maps.google.com/?q=Bakelore Madhapur Experience Centre",
//       timings: "8:30 AM – 12 Midnight",
//       phone: "+918121034991",
//     },
//     {
//       img: "https://bakelore.com/images/Bakelore-Banjara-Hills-Flagship-Retail-Store.png",
//       title: "Bakelore Banjara Hills Flagship Retail Store",
//       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
//       address:
//         "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
//       map: "https://maps.google.com/?q=Bakelore Banjara Hills Flagship Retail Store",
//       timings: "8:30 AM – 12 Midnight",
//       phone: "+918121034992",
//     },
//     {
//       img: "https://bakelore.com/images/Bakelore-Kondapur-Flagship-Retail-Store.png",
//       title: "Bakelore Kondapur Flagship Retail Store",
//       desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
//       address:
//         "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
//       map: "https://maps.google.com/?q=Bakelore Kondapur Flagship Retail Store",
//       timings: "8:30 AM – 12 Midnight",
//       phone: "+918121034983",
//     },
//     {
//       img: "https://bakelore.com/images/bakelore-kokapet-to-go-store.png",
//       title: "Bakelore Kokapet To-Go Store",
//       desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
//       address:
//         "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
//       map: "https://maps.google.com/?q=Bakelore Kokapet To-Go Store",
//       timings: "8:30 AM – 12 Midnight",
//       phone: "+917997000791",
//     },
//   ];

//   return (
//     <div className="stores-wrapper">
//       <h1 className="stores-title">STORES INFO</h1>

//       <div className="stores-grid">
//         {stores.map((item, index) => (
//           <div className="store-card" key={index}>

//             {/* Image */}
//             <div className="arch-image">
//               <img src={item.img} alt={item.title} />
//             </div>

//             {/* NEW BEAUTIFUL CONTENT CARD */}
//             <div className="store-content">
//               <h3 className="store-title">{item.title}</h3>
//               <p className="store-desc">{item.desc}</p>

//               <div className="info-list">

//                 {/* Address */}
//                 <p className="info-item">
//                   <span className="icon-circle"><MdLocationOn /></span>
//                   <a
//                     href={item.map}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="info-text"
//                   >
//                     {item.address}
//                   </a>
//                 </p>

//                 {/* Timings */}
//                 <p className="info-item">
//                   <span className="icon-circle"><MdAccessTime /></span>
//                   <span className="info-text">{item.timings}</span>
//                 </p>

//                 {/* Phone */}
//                 <p className="info-item">
//                   <span className="icon-circle"><MdPhone /></span>
//                   <a href={`tel:${item.phone}`} className="info-text">
//                     {item.phone}
//                   </a>
//                 </p>

//               </div>
//             </div>

//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default StoresInfo;


import React from "react";
import "./StoresInfo.css";

// React Icons
import { MdLocationOn, MdAccessTime, MdPhone } from "react-icons/md";

const StoresInfo = () => {
  const stores = [
    {
      img: "https://bakelore.com/images/Bakelore-Madhapur-Experience-Centre.png",
      title: "Bakelore Madhapur",
      desc: "Welcome to the Bakelore Experience Centre — our hub for desserts, savoury, coffee, and creation.",
      address:
        "1-103/5/1, Ground Floor, 1st Floor & Terrace Floor, Hitec City, Sri Nagar Colony, Madhapur, Hyderabad",
      map: "https://maps.google.com/?q=Bakelore Madhapur Experience Centre",
      timings: "8:30 AM – 12 Midnight",
      phone: "+918121034991",
    },
    {
      img: "https://bakelore.com/images/Bakelore-Banjara-Hills-Flagship-Retail-Store.png",
      title: "Bakelore Banjara",
      desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
      address:
        "House 8-2-323/1/B, Ubi Colony, Green Valley Road 3, Banjara Hills, Hyderabad",
      map: "https://maps.google.com/?q=Bakelore Banjara Hills Flagship Retail Store",
      timings: "8:30 AM – 12 Midnight",
      phone: "+918121034992",
    },
    {
      img: "https://bakelore.com/images/Bakelore-Kondapur-Flagship-Retail-Store.png",
      title: "Bakelore Kondapur",
      desc: "Our Flagship Retail Store offers the best of Bakelore — desserts, coffee, savoury and cozy corners.",
      address:
        "Plot 60, Ground Floor, Masjid Banda, Cement Layout, Kondapur, Hyderabad",
      map: "https://maps.google.com/?q=Bakelore Kondapur Flagship Retail Store",
      timings: "8:30 AM – 12 Midnight",
      phone: "+918121034993",
    },
    {
      img: "https://bakelore.com/images/bakelore-kokapet-to-go-store.png",
      title: "Bakelore Kokapet",
      desc: "Pick up your coffee, dessert, sandwich or cake on the run with cozy seats to stay.",
      address:
        "98DW+4JG, Snaap, Ganderp Nagar, Power Welfare Society, Manchirevula, Kokapet, Hyderabad",
      map: "https://maps.google.com/?q=Bakelore Kokapet To-Go Store",
      timings: "8:30 AM – 12 Midnight",
      phone: "+917997000791",
    },
  ];

  // 🔹 Title split helper
  const splitTitle = (title) => {
    const words = title.split(" ");
    return {
      firstLine: words.slice(0, 2).join(" "),
      secondLine: words.slice(2).join(" "),
    };
  };

  return (
    <div className="stores-wrapper">
      <h1 className="stores-title">STORES INFO</h1>

      <div className="stores-grid">
        {stores.map((item, index) => {
          const { firstLine, secondLine } = splitTitle(item.title);

          return (
            <div className="store-card" key={index}>
              {/* Image */}
              <div className="arch-image">
                <img src={item.img} alt={item.title} />
              </div>

              {/* Content */}
              <div className="store-content">
                <h3 className="store-title">
                  {firstLine}
                  <br />
                  <span>{secondLine}</span>
                </h3>

                <p className="store-desc">{item.desc}</p>

                <div className="info-list">
                  {/* Address */}
                  <p className="info-item">
                    <span className="icon-circle">
                      <MdLocationOn />
                    </span>
                    <a
                      href={item.map}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="info-text"
                    >
                      {item.address}
                    </a>
                  </p>

                  {/* Timings */}
                  <p className="info-item">
                    <span className="icon-circle">
                      <MdAccessTime />
                    </span>
                    <span className="info-text">{item.timings}</span>
                  </p>

                  {/* Phone */}
                  <p className="info-item">
                    <span className="icon-circle">
                      <MdPhone />
                    </span>
                    <a href={`tel:${item.phone}`} className="info-text">
                      {item.phone}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StoresInfo;
